import React, { useState } from "react";
import styled from "styled-components";
import { useAuth } from "@/lib/Authentication/hooks/useAuth";
import {
  filterMePageItems,
  mePageItemsEnum,
} from "../../elements/CustomerProfile/consts";
import { useStore } from "@/lib/storeData/StoreContext";
import { themeColor } from "@/shared/styles-utils";
import Flex from "@/shared/globals/UiElements/Flex";
import { FlexRow, H3, P } from "@/shared/globals";
import { LogoutSimpleIcon } from "@/assets/Icons/LogoutSimpleIcon";
import { LongTailRightArrow } from "@/assets/Icons/LongTailRightArrow";
import { Link } from "@/i18n/i18n-navigation";
import CentralizedModal from "@/components/Centralizedlogin/CentralizedModal";
import { AuthMode } from "@/generated/graphql";
import { FormattedMessage } from "@/i18n/i18n-client";
import { CustomerIcon } from "@/assets/Icons/CustomerIcon";

const AccountButton = ({
  closeAccountTab,
}: {
  closeAccountTab: () => void;
}) => {
  const { user, isLoggedIn, logout } = useAuth();
  const { areReviewsActivated, authMode } = useStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLoginClick = () => {
    if (authMode === AuthMode.Modern) {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      {isLoggedIn ? (
        <Container>
          <BasicInfo column verticalSpacing="m">
            <H3 fontSize="18px" fontWeight={600}>
              {user?.name}
            </H3>
            <P style={{ opacity: 0.5 }}>{user?.email}</P>
          </BasicInfo>
          {filterMePageItems(areReviewsActivated).map((item) =>
            item.id !== mePageItemsEnum.LogOut ? (
              <Link key={item.id} href={`/me/${item.slug}/`}>
                <StyledButton
                  justifyContent="space-between"
                  onClick={closeAccountTab}
                >
                  <H3>{item.title}</H3>
                  <LongTailRightArrow />
                </StyledButton>
              </Link>
            ) : (
              <LogoutButton
                key={item.id}
                spacing="s"
                onClick={() => {
                  logout();
                  closeAccountTab();
                }}
              >
                <LogoutSimpleIcon />
                <H3 fontSize="14px" fontWeight={600}>
                  {item.title}
                </H3>
              </LogoutButton>
            )
          )}
        </Container>
      ) : authMode === AuthMode.Modern ? (
        <>
          <Container>
            <LoginButton spacing="s" onClick={handleLoginClick}>
              <CustomerIcon width="20px" height="20px" />
              <H3 fontSize="14px" fontWeight={600}>
                <FormattedMessage defaultMessage="Login" id="AyGauy" />
              </H3>
            </LoginButton>
          </Container>
          <CentralizedModal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
          />
        </>
      ) : (
        <Container>
          <Link href={"/login"}>
            <LoginButton spacing="s" onClick={closeAccountTab}>
              <CustomerIcon width="20px" height="20px" />
              <H3 fontSize="14px" fontWeight={600}>
                <FormattedMessage defaultMessage="Login" id="AyGauy" />
              </H3>
            </LoginButton>
          </Link>
        </Container>
      )}
    </>
  );
};

export default AccountButton;

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

const BasicInfo = styled(Flex)`
  padding: 0 16px 16px;
`;

const StyledButton = styled(FlexRow)`
  border-bottom: 2px solid ${({ theme }) => theme.bg.reverse};
  background-color: ${themeColor("white")};
  padding: 16px;
  svg {
    transform: ${({ theme: { isRTL } }) => isRTL && "rotate(180deg)"};
  }
`;

const LogoutButton = styled(FlexRow)`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 16px;
  background-color: ${({ theme }) => theme.danger.default}1a;
  > h3 {
    color: ${({ theme }) => theme.danger.default};
  }
`;

const LoginButton = styled(FlexRow)`
  width: 100%;
  padding: 16px;
  background-color: ${themeColor("white")};
  border-bottom: 2px solid ${({ theme }) => theme.bg.reverse};
  cursor: pointer;
`;
